import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiOutlineMail
} from "react-icons/ai";
import { FaLinkedinIn, FaHackerrank } from "react-icons/fa";
import {
   SiResearchgate, SiInstagram,SiTiktok } from "react-icons/si";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <hr
        style={{
          background: 'gray',
          height: '2px',
        }}
      />
      <br></br>
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Copyright ©  {year}</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Hemang Sharma</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="mailto:sharmahemang2000@gmail.com"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer canonical"
              >
                <AiOutlineMail />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/sharmahemang/"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer canonical"
              >
                <FaLinkedinIn />
              </a>
            </li>
              <li className="social-icons">
                <a
                  href="https://www.researchgate.net/profile/Hemang-Sharma-4"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "white" }}
                >
                  <SiResearchgate />
                </a>
              </li>
            </ul>
        </Col>
      </Row>
      <Row>
        <Col md="4" className="footer-body">
          <h3><a rel="noopener noreferrer canonical" href="https://sharmahemang.com/pp.html" target="_blank">Privacy Policy</a></h3>
        </Col>
        <Col md="4" className="footer-body">
          <h3><a rel="noopener noreferrer canonical" href="https://certificates.sharmahemang.com/" target="_blank">Certificates</a></h3>
        </Col>
        <Col md="4" className="footer-body">
          <h3><a rel="noopener noreferrer canonical" href="https://sharmahemang.com/sitemap.xml" target="_blank">Sitemap</a></h3>
        </Col>
      </Row>
      <br></br><br></br>
    </Container>
  );
}

export default Footer;
